export interface AppCommonUserInformation {
  id: string;
  content: {
    name: string;
    surname: string;
    foot: string;
    birthday: string;
    position: string;
    height: number;
    weight: number;
    avatar: string;
    contract: {
      club: string,
      from: string,
      to: string,
      position: string;
      type: string;
    };
    sponsor: {
      name: string,
      from: string,
      to: string,
    };
  };
}

export class AppCommonUserInformation implements AppCommonUserInformation {
  id: string;
  content: {
    name: string;
    surname: string;
    foot: string;
    birthday: string;
    position: string;
    height: number;
    weight: number;
    avatar: string;
    contract: {
      club: string,
      from: string,
      to: string,
      position: string;
      type: string;
    };
    sponsor: {
      name: string,
      from: string,
      to: string,
    };
  };

  constructor() {
    this.id = "";
    this.content = {
      name: "",
      surname: "",
      foot: "",
      birthday: "",
      position: "",
      height: null,
      weight: null,
      avatar: "",
      contract: {
        club: "",
        from: "",
        to: "",
        position: "",
        type: "",
      },
      sponsor: {
        name: "",
        from: "",
        to: "",
      },
    };
  }
}